module.exports = __webpack_public_path__ + "img/1696562048314-nib noorma aslianti.jpeg.48173341.webp";